module.exports = __webpack_public_path__ + "static/media/clubpoints-white.1ae6de38.svg";